import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../AuthContext";

const EnquiryForm = () => {
  const { apipath } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    phoneNo: "",
    email: "",
    address: "",
    message: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Phone number validation - only digits and max 10 characters
    if (name === 'phoneNo') {
      // Remove any non-digit characters
      const digitsOnly = value.replace(/\D/g, '');
      // Limit to 10 digits
      if (digitsOnly.length <= 10) {
        setFormData({ ...formData, [name]: digitsOnly });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate phone number
    if (formData.phoneNo.length !== 10) {
      setError("Phone number must be exactly 10 digits.");
      setSuccess("");
      return;
    }
    
    try {
      const response = await axios.post(`${apipath}/enquireNow/add`, formData);
      if (response.data.success) {
        setSuccess("Enquiry submitted successfully!");
        setFormData({
          name: "",
          phoneNo: "",
          email: "",
          address: "",
          message: "",
        });
        setError("");
      }
    } catch (err) {
      setError("Failed to submit enquiry. Please try again.");
      setSuccess("");
    }
  };

  const handleContactUsClick = () => {
    setShowThankYouPopup(true);
    // Clear form data after showing popup
    setFormData({
      name: "",
      phoneNo: "",
      email: "",
      address: "",
      message: "",
    });
  };

  const closeThankYouPopup = () => {
    setShowThankYouPopup(false);
  };

  return (
    <div className="container enquiry">
      <div className="main-heading">
        <h1>
          E<span>nquire No</span>w
        </h1>
      </div>
      <div className="my-4 lg:p-5 p-3 w-full lg:w-8/12 bg-enquiry rounded-[10px] mx-auto">
        <form onSubmit={handleSubmit} className="flex flex-wrap">
          <div className="w-full md:w-6/12 p-2">
            <div>
              <label
                htmlFor="name"
                className="block font-poppins font-medium text-lg mb-1"
              >
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
                placeholder="Name"
                required
              />
            </div>
          </div>
          <div className="w-full md:w-6/12 p-2">
            <div>
              <label
                htmlFor="phoneNo"
                className="block font-poppins font-medium text-lg mb-1"
              >
                Phone No.
              </label>
              <input
                type="tel"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleChange}
                className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
                placeholder="Enter 10 digit phone number"
                maxLength="10"
                pattern="[0-9]{10}"
                title="Please enter exactly 10 digits"
                required
              />
            </div>
          </div>
          <div className="w-full md:w-6/12 p-2">
            <div>
              <label
                htmlFor="email"
                className="block font-poppins font-medium text-lg mb-1"
              >
                Email
              </label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
                placeholder="Email"
                required
              />
            </div>
          </div>
          <div className="w-full md:w-6/12 p-2">
            <div>
              <label
                htmlFor="address"
                className="block font-poppins font-medium text-lg mb-1"
              >
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
                placeholder="Address"
                required
              />
            </div>
          </div>
          <div className="w-full p-2">
            <div>
              <label
                htmlFor="message"
                className="block font-poppins font-medium text-lg mb-1"
              >
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
                placeholder="Message"
                required
              ></textarea>
            </div>
          </div>
          <div className="p-2 flex gap-3">
            <button
              type="submit"
              className="rounded-[10px] bg-enquiry-button font-poppins font-medium text-white text-lg py-1 px-4"
            >
              Send
            </button>
            <button
              type="button"
              onClick={handleContactUsClick}
              className="w-full font-raleway font-medium text-base text-white py-1 bg-dark-yellow rounded-[10px] px-4"
            >
              Contact Us
            </button>
          </div>
          {error && <div className="p-2 text-red-500">{error}</div>}
          {success && <div className="p-2 text-green-500">{success}</div>}
        </form>
      </div>

      {/* Thank You Popup Modal */}
      {showThankYouPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all duration-300 scale-100 relative">
            {/* Close Icon */}
            <button
              onClick={closeThankYouPopup}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            
            <div className="p-8 text-center">
              {/* Success Icon */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
                <svg
                  className="h-8 w-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              
              {/* Thank You Message */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-poppins">
                Thank You! 🎉
              </h3>
              <p className="text-gray-600 mb-6 font-poppins text-base leading-relaxed">
                We appreciate your interest in contacting us! Our team will get back to you soon with all the information you need.
              </p>
              
              {/* Contact Info */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <p className="text-sm text-gray-700 font-medium mb-2">
                  📞 Call us directly: <span className="text-blue-600">+91-804 794 6943</span>
                </p>
                <p className="text-sm text-gray-700 font-medium">
                  ✉️ Email: <span className="text-blue-600">sales@narayanaluminium.com</span>
                </p>
              </div>
              
              {/* Close Button */}
              <button
                onClick={closeThankYouPopup}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Got it! ✨
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnquiryForm;
